{
	"content": {
		"declarationDetailsSection": {
			"title": "Detalii declarație",
			"description": "Pentru a crea declarația, sunt necesare numele clientului, adresa și țara deținătorului declarației. Informațiile nu pot fi schimbate ulterior.",
			"customerLabel": "Cont client"
		},
		"provideDeclarationsDetailsSection": {
			"title": "Furnizați detaliile declarației",
			"alertDescription": "Informațiile pe care le furnizați vor fi înregistrate permanent în declarație și nu vor putea fi modificate ulterior.",
			"projectLabel": "Referință proiect",
			"companyNameLabel": "Nume companie",
			"streetLabel": "Stradă",
			"zipCodeLabel": "Cod poștal",
			"cityLabel": "Oraș",
			"countryLabel": "Țară"
		}
	},
	"summary": {
		"title": "Rezumat",
		"declarationTypeTitle": "Tip declarație",
		"customerProjectTitle": "Proiect client",
		"internalProjectOrProductTitle": "Proiect intern / produs",
		"projectReferenceTitle": "Referință proiect",
		"materialHeaderTitle": "Material",
		"quantityHeaderTitle": "Cantitate ({{unit}})",
		"totalTransferableCarbonReductionsTitle": "Reduceri de CO\u2082 alocabile ({{unit}})",
		"nonTransferableCarbonReductionTitle": "Reducere de CO\u2082 nealocabilă ({{unit}})"
	},
	"errorMessages": {
		"projectRequired": "Referința proiectului este obligatorie",
		"companyNameRequired": "Numele companiei este obligatoriu",
		"streetRequired": "Strada este obligatorie",
		"zipCodeRequired": "Codul poștal este obligatoriu",
		"cityRequired": "Orașul este obligatoriu",
		"countryRequired": "Țara este obligatorie",
		"customerRequired": "Clientul este obligatoriu"
	},
	"reviewDeclarationDetailsModal": {
		"title": "Revizuiește rezumatul declarației",
		"description": "Vă rugăm să verificați datele introduse pentru eventuale greșeli.",
		"alertDescription": "Informațiile pe care le-ați furnizat vor fi înregistrate permanent în declarație și nu vor putea fi modificate ulterior.",
		"typeSectionTitle": "1. Tip",
		"declarationTypeLabel": "Tip declarație",
		"customerProjectTitle": "Proiect client",
		"internalProjectOrProductTitle": "Proiect intern / produs",
		"projectReferenceLabel": "Referință proiect",
		"materialSectionTitle": "2. Material",
		"materialHeaderTitle": "Material",
		"quantityHeaderTitle": "Cantitate ({{unit}})",
		"totalCarbonReductionsLabel": "Reduceri totale de CO₂ ({{unit}})",
		"declarationSectionTitle": "3. Declarație",
		"companyNameLabel": "Nume companie",
		"streetLabel": "Stradă",
		"zipCodeLabel": "Cod poștal",
		"cityLabel": "Oraș",
		"countryLabel": "Țară",
		"backTitle": "Înapoi",
		"submitTitle": "Da, totul este corect"
	},
	"submitTitle": "Creează declarație",
	"backTitle": "Înapoi"
}
